import { Button, Grow, Typography } from "@mui/material";
import { Box } from "@mui/system";
import { FirstLetterCaps, rootColorFilter, sortFishboneKeys } from "../../../Helpers/NCRHelpers";
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery'

export const FishBoneDiagramViewOnlyMode = ({ ncrData }) => {

  const theme = useTheme();
  const isCustom = useMediaQuery('(min-width:1500px) and (max-width:1800px)')
  const isLaptop = useMediaQuery(theme.breakpoints.only('lg')) || isCustom
  const isCustom1 = useMediaQuery('(min-width:1200px) and (max-width:1350px)')
  const isTab = useMediaQuery(theme.breakpoints.down('lg')) || isCustom1

  const renderFishBoneTextField = ({
    field,
    index,
  }) => {
    const item = ncrData?.fb_diagram?.[field.toLowerCase()]?.[index];
    const capsMatch = item?.data?.match(/[A-Z]/g);
    const hasMoreThanOneUppercase = capsMatch && capsMatch.length > 1;

    const inCaps = hasMoreThanOneUppercase ? 19 : 21;

    const displayValue = item?.data?.length > inCaps ? item.data.slice(0, inCaps) + "..." : item?.data || "";

    return <Box sx={{
      marginTop: "5px",
      color: (displayValue && !item?.is_highlighted) ? '#616a6b' : (displayValue && item?.is_highlighted) ? 'white' : "rgba(128, 128, 128, 1)",
      maxHeight: isTab ? '20px' : isLaptop ? '30px' : '45px',
      padding: isTab ? '5px' : '8px 14px',
      fontSize: (isTab && displayValue) ? '5.5px' : (isTab && !displayValue) ? '5px' : (isLaptop && displayValue) ? '8px' : (isLaptop && !displayValue) ? '9px' : displayValue ? '13px' : '14px',
      minWidth: '100%',
      width: isTab ? '72px' : isLaptop ? '120px' : "175px",
      border: (!displayValue && !item?.is_highlighted) && "1px solid rgba(128, 128, 128, 0.4)",
      borderRadius: isTab ? '3px' : isLaptop ? '4px' : "5px",
      display: "flex",
      alignItems: 'center',
      justifyContent: (displayValue && !item?.is_highlighted) ? "right" : displayValue ? "center" : 'center',
      backgroundColor: item?.is_highlighted ? rootColorFilter(field) : 'transparent',
      fontWeight: (displayValue) && 600,
    }}>
      {displayValue ? FirstLetterCaps(displayValue) : 'No data entered'}
    </Box>
  };

  return (
    <Grow
      in={true}
      style={{ transformOrigin: '0 0 0' }}
      timeout={1000}
    >
      <Box sx={{ p: 3 }}>
        <Box sx={{ overflow: "auto" }}>
          <div style={{ position: 'relative', margin: '0 auto', zIndex: 0 }}>
            <img
              src="/images/fish.png"
              style={{ width: '100%', height: 'auto', display: 'block' }}
              alt="fish"
            />
            <div>
              <Typography style={{ fontFamily: 'Lato, sans-serif', position: 'absolute', top: '12%', left: '18%', transform: 'translate(-50%, -50%)', fontWeight: 600, color: '#fff', fontSize: isTab ? '8px' : isLaptop && '12.5px' }}>MANPOWER</Typography>
              <div style={{ position: 'absolute', top: '23%', left: '17.5%', transform: 'translate(-50%, -50%)', padding: '0 2px', borderRadius: "5px" }}>
                {renderFishBoneTextField({ field: 'MANPOWER', index: 0, color: '#FCB433' })}
              </div>
              <div style={{ position: 'absolute', top: '31%', left: '21.5%', transform: 'translate(-50%, -50%)', padding: '0 2px', borderRadius: "5px" }}>
                {renderFishBoneTextField({ field: 'MANPOWER', index: 1, color: '#FCB433' })}
              </div>
              <div style={{ position: 'absolute', top: '38.5%', left: '25.2%', transform: 'translate(-50%, -50%)', padding: '0 2px', borderRadius: "5px" }}>
                {renderFishBoneTextField({ field: 'MANPOWER', index: 2, color: '#FCB433' })}
              </div>
            </div>
            <div>
              <Typography style={{ fontFamily: 'Lato, sans-serif', position: 'absolute', top: '12%', left: '34%', transform: 'translate(-50%, -50%)', fontWeight: 600, color: '#fff', fontSize: isTab ? '8px' : isLaptop && '12.5px' }}>METHOD</Typography>
              <div style={{ position: 'absolute', top: '23%', left: '33.8%', transform: 'translate(-50%, -50%)', padding: '0 2px', borderRadius: "5px" }}>
                {renderFishBoneTextField({ field: 'METHOD', index: 0, color: '#F14B62' })}
              </div>
              <div style={{ position: 'absolute', top: '31%', left: '37.7%', transform: 'translate(-50%, -50%)', padding: '0 2px', borderRadius: "5px" }}>
                {renderFishBoneTextField({ field: 'METHOD', index: 1, color: '#F14B62' })}
              </div>
              <div style={{ position: 'absolute', top: '38%', left: '41.3%', transform: 'translate(-50%, -50%)', padding: '0 2px', borderRadius: "5px" }}>
                {renderFishBoneTextField({ field: 'METHOD', index: 2, color: '#F14B62' })}
              </div>
            </div>
            <div>
              <Typography style={{ fontFamily: 'Lato, sans-serif', position: 'absolute', top: '12%', left: '50%', transform: 'translate(-50%, -50%)', fontWeight: 600, color: '#fff', fontSize: isTab ? '8px' : isLaptop && '12.5px' }}>MACHINE</Typography>
              <div style={{ position: 'absolute', top: '23%', left: '49.8%', transform: 'translate(-50%, -50%)', padding: '0 2px', borderRadius: "5px" }}>
                {renderFishBoneTextField({ field: 'MACHINE', index: 0, color: '#BC3743' })}
              </div>
              <div style={{ position: 'absolute', top: '31%', left: '53.7%', transform: 'translate(-50%, -50%)', padding: '0 2px', borderRadius: "5px" }}>
                {renderFishBoneTextField({ field: 'MACHINE', index: 1, color: '#BC3743' })}
              </div>
              <div style={{ position: 'absolute', top: '38.5%', left: '57.3%', transform: 'translate(-50%, -50%)', padding: '0 2px', borderRadius: "5px" }}>
                {renderFishBoneTextField({ field: 'MACHINE', index: 2, color: '#BC3743' })}
              </div>
            </div>
            <div>
              <Typography style={{ fontFamily: 'Lato, sans-serif', position: 'absolute', bottom: '11%', left: '50%', transform: 'translate(-50%, -50%)', fontWeight: 600, color: '#fff', fontSize: isTab ? '8px' : isLaptop && '12.5px' }}>MEASUREMENT</Typography>
              <div style={{ position: 'absolute', top: '59%', left: '57.5%', transform: 'translate(-50%, -50%)', padding: '0 2px', borderRadius: "5px", color: 'black' }}>
                {renderFishBoneTextField({ field: 'MEASUREMENT', index: 0, color: '#66C068' })}
              </div>
              <div style={{ position: 'absolute', top: '66.8%', left: '53.7%', transform: 'translate(-50%, -50%)', padding: '0 2px', borderRadius: "5px" }}>
                {renderFishBoneTextField({ field: 'MEASUREMENT', index: 1, color: '#66C168' })}
              </div>
              <div style={{ position: 'absolute', top: '74%', left: '49.8%', transform: 'translate(-50%, -50%)', padding: '0 2px', borderRadius: "5px" }}>
                {renderFishBoneTextField({ field: 'MEASUREMENT', index: 2, color: '#66C268' })}
              </div>
            </div>
            <div>
              <Typography style={{ fontFamily: 'Lato, sans-serif', position: 'absolute', bottom: '11%', left: '34%', transform: 'translate(-50%, -50%)', fontWeight: 600, color: '#fff', fontSize: isTab ? '8px' : isLaptop && '12.5px' }}>ENVIRONMENT</Typography>
              <div style={{ position: 'absolute', top: '59%', left: '41.5%', transform: 'translate(-50%, -50%)', padding: '0 2px', borderRadius: "5px", color: 'black' }}>
                {renderFishBoneTextField({ field: 'ENVIRONMENT', index: 0, color: '#3DC1F2' })}
              </div>
              <div style={{ position: 'absolute', top: '67%', left: '37.8%', transform: 'translate(-50%, -50%)', padding: '0 2px', borderRadius: "5px" }}>
                {renderFishBoneTextField({ field: 'ENVIRONMENT', index: 1, color: '#3DC1F2' })}
              </div>
              <div style={{ position: 'absolute', top: '74%', left: '34%', transform: 'translate(-50%, -50%)', padding: '0 2px', borderRadius: "5px" }}>
                {renderFishBoneTextField({ field: 'ENVIRONMENT', index: 2, color: '#3DC1F2' })}
              </div>
            </div>
            <div>
              <Typography style={{ fontFamily: 'Lato, sans-serif', position: 'absolute', bottom: '11%', left: '18%', transform: 'translate(-50%, -50%)', fontWeight: 600, color: '#fff', fontSize: isTab ? '8px' : isLaptop && '12.5px' }}>MATERIAL</Typography>
              <div style={{ position: 'absolute', top: '59%', left: '25.5%', transform: 'translate(-50%, -50%)', padding: '0 2px', borderRadius: "5px", color: 'black' }}>
                {renderFishBoneTextField({ field: 'MATERIAL', index: 0, color: '#A66DF5' })}
              </div>
              <div style={{ position: 'absolute', top: '66.5%', left: '21.7%', transform: 'translate(-50%, -50%)', padding: '0 2px', borderRadius: "5px" }}>
                {renderFishBoneTextField({ field: 'MATERIAL', index: 1, color: '#A66DF5' })}
              </div>
              <div style={{ position: 'absolute', top: '74%', left: '18%', transform: 'translate(-50%, -50%)', padding: '0 2px', borderRadius: "5px" }}>
                {renderFishBoneTextField({ field: 'MATERIAL', index: 2, color: '#A66DF5' })}
              </div>
            </div>
            <Box style={{ position: 'absolute', top: '50%', right: isLaptop ? '4%' : '2.5%', transform: 'translate(-50%, -50%)', padding: '0 2px', width: isTab ? '90px' : isLaptop ? '130px' : "200px", height: isTab ? '35px' : isLaptop ? '60px' : "80px", borderRadius: "5px", backgroundColor: "#F14B62", display: 'flex', justifyContent: "center", alignItems: "center" }}>
              <div style={{ position: "relative" }}>
                <Button sx={{
                  fontFamily: 'Lato, sans-serif', cursor: "pointer", color: "#fff", fontWeight: 600, fontSize: isTab ? '10px' : isLaptop ? '15px' : "25px"
                }}>
                  PROBLEM
                </Button>
              </div>
            </Box>
            <div style={{
              position: 'absolute', top: '75%', right: isTab ? '-18%' : isLaptop ? '-13%' : '-7.5%', transform: 'translate(-50%, -50%)', padding: '0 2px', borderRadius: "10px",
              width: isTab ? '230px' : isLaptop ? '300px' : "350px",
              height: 'auto',
              boxShadow: "2px 2px 5px rgba(0, 0, 0, 0.1)",
            }}
            >
              <Typography sx={{
                fontFamily: 'Lato, sans-serif',
                p: 2,
                backgroundColor: "#f2f3f4",
                height: '48px',
                fontSize: isTab ? '13px' : isLaptop ? '16px' : ''
              }}>
                What went wrong ?
              </Typography>
              <Typography sx={{
                fontFamily: 'Lato, sans-serif',
                p: 2,
                backgroundColor: "white",
                fontSize: isTab ? '10px' : isLaptop ? '15px' : ''
              }}>
                {FirstLetterCaps(ncrData?.what_went_wrong + '.') || '-'}
              </Typography>
            </div>
          </div>
        </Box>
        {Object.entries(ncrData?.fb_diagram)?.flatMap(([category, items]) => items?.filter(item => item.is_highlighted))?.length > 0 && <Typography sx={{ fontSize: "20px", margin: '0 auto' }}>
          Highlighted Sub-cause
        </Typography>}
        <div style={{ width: "100%", display: "flex", alignContent: "center", gap: "10px", flexWrap: "wrap", marginTop: "15px" }}>
          {Object.entries(sortFishboneKeys(ncrData?.fb_diagram))?.flatMap(([category, items]) =>
            items?.filter(item => item.is_highlighted)?.map(item => {
              const enrichedItem = { ...item, rootName: category };
              return (
                <div key={`${category}-${item.id}`} style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                  <img
                    alt="fish-bone-diagram"
                    src={`/images/${category} Star.png`}
                    style={{
                      width: '35px',
                      height: "30px",
                    }}
                  />
                  {enrichedItem?.data}
                </div>
              );
            })
          )}
        </div>
      </Box>
    </Grow>
  )
}